import { render, staticRenderFns } from "./ProgramStats.vue?vue&type=template&id=ab6de140&scoped=true&"
import script from "./ProgramStats.vue?vue&type=script&lang=js&"
export * from "./ProgramStats.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStats.vue?vue&type=style&index=0&id=ab6de140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6de140",
  null
  
)

export default component.exports